
import { useState, useRef } from "react";
import { Session, User } from "@supabase/supabase-js";

// Enhanced security settings
export const AUTH_SETTINGS = {
  maxFailedAttempts: 5,
  lockoutDuration: 15 * 60 * 1000, // 15 minutes in milliseconds
  sessionTimeout: 60 * 60 * 1000, // 1 hour in milliseconds
};

/**
 * Custom hook to manage authentication state
 */
export const useAuthState = () => {
  const [session, setSession] = useState<Session | null>(null);
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const isMounted = useRef(true);
  const authTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const sessionCheckIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const lastActivityRef = useRef<number>(Date.now());
  
  // Track failed login attempts
  const [failedAttempts, setFailedAttempts] = useState<Record<string, {count: number, lastFailure: number}>>({});
  
  return {
    session,
    setSession,
    user,
    setUser,
    isLoading,
    setIsLoading,
    isMounted,
    authTimeoutRef,
    sessionCheckIntervalRef,
    lastActivityRef,
    failedAttempts,
    setFailedAttempts
  };
};

export type AuthStateType = ReturnType<typeof useAuthState>;
